import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SessionService } from '../../providers/session.service';
import { AlertService } from '../../providers/alert.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigsService } from '../../providers/configs.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { map } from 'rxjs/operators';
import { error } from '@angular/compiler/src/util';


@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss', '../../assets/less/all.less']
})
// const httpOptions = {
// 	headers: new HttpHeaders({
// 		'Content-Type': 'application/json',
// 		'Authorization': 'my-auth-token'
// 	})
// };

export class LoginComponent implements OnInit {
	user = { email: '', password: '' };
	loading = false
	constructor(
		public http: HttpClient,
		private router: Router,
		public configs: ConfigsService,
		public alerts: AlertService,
		public dialog: MatDialog,
		public session: SessionService,
	) { }


	ngOnInit() {
	}


	login() {
		let headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});
		let options = {
			headers: headers
		}
		// let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbkBlbWFpbC5jb20iLZTSXgi164MCGG3u5RKXaBGVBabmxQTVRAAVE5tDTTkxOH0.rPJoczaXbMDXznIBarZjBqjZCyB6kTP1PpgvYMC0w7U"
		// headers.append('Authorization', 'Bearer ' + token)
		
		let param = { username: this.user.email, password: this.user.password }

		console.log('user enviando', this.user),
		this.http.post(this.configs.getEndpoint() + 'users/authenticate', this.user, options)
			.subscribe(data => {
				console.log(data);
				if (data['accessToken']) {
                    this.session.setSessao(data);
                    this.loading=false;
                    this.router.navigate(['/documentos-ged'])
                } else {
                    this.alerts.openAlert('Ops', 'Usuário e/ou senha estão incorretos.');
                    this.loading=false;
                }
			},
			error => {
				
				this.loading=false;
				this.alerts.openAlert('Ops', 'Usuário e/ou senha estão incorretos.');
			});
	}


}
